import { Button } from '@components/core-ui/form-elements/buttons/Button/';
import { OutlinedButton } from '@components/core-ui/form-elements/buttons/Button/variations/OutlinedButton';
import { AbsoluteSpinner } from '@components/core-ui/spinners/Spinner';
import { ModalWrapper } from '@modals/core-ui/ModalWrapper';
import { ModalTitle } from '@modals/core-ui/ModalTitle';
import { useAPI } from '@providers/useAPI';
import { useMutation } from '@tanstack/react-query';
import { RepositoriesService } from 'app/API';
import { ApiCallError } from 'app/http/ApiCallError';
import { getApiCallErrorMessage } from 'app/http/getApiCallErrorMessage';
import { TRepository } from 'app/types/entities/TRepository';
import { useState } from 'react';

type TProps = {
  repository: TRepository;
  onCancel: () => void;
  onSuccess: () => void;
};

export const DeleteRepositoryModal = ({ repository, onCancel, onSuccess }: TProps) => {
  const { call } = useAPI();
  const [error, setError] = useState<string | null>(null);

  const deleteRepositoryMutation = useMutation({
    mutationFn: () => call(() => RepositoriesService.remove({ repositoryId: repository.id })),
    onMutate: () => {
      setError(null);
    },
    onSuccess: (data) => {
      if (data.error) {
        setError(data.error as string);
        return;
      }
      onSuccess();
    },
    onError: (mutationError) => {
      setError(mutationError instanceof ApiCallError ? getApiCallErrorMessage(mutationError) : 'Something went wrong.');
    },
  });

  return (
    <ModalWrapper width="330px">
      <ModalTitle>Confirm</ModalTitle>
      {deleteRepositoryMutation.isPending ? <AbsoluteSpinner overlay={true} /> : null}
      <div className="text-center">
        Are you sure you want to delete &quot;{repository.name}&quot;? <br />
        Associated attachments will also be deleted.
      </div>
      {error && <div className="-mt-5 text-center text-[10px] font-medium text-[#ff2f2f]">{error}</div>}
      <div className="flex justify-between">
        <OutlinedButton onClick={onCancel} style={{ width: '130px' }}>
          Cancel
        </OutlinedButton>
        <Button
          onClick={() => deleteRepositoryMutation.mutate()}
          disabled={deleteRepositoryMutation.isPending}
          style={{ width: '130px' }}
        >
          Delete
        </Button>
      </div>
    </ModalWrapper>
  );
};
